import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TableCell, TableRow, Typography } from '@mui/material';
import SvgIconStyle from 'components/SvgIconStyle';
import { renderRowCreatedAt } from 'utils/renderTableCell';

export function TagsRow({ row, index }) {
  const navigate = useNavigate();
  const { createdAt, asQuestionsInput, asQuestionsOutput, name, category, level, status } = row;
  return (
    <>
      <TableRow key={index} hover>
        <TableCell align="left">
          <Typography>{index + 1}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{renderRowCreatedAt('fa-IR', createdAt)}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{name}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{category}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{level}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{asQuestionsInput}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{asQuestionsOutput}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{status}</Typography>
        </TableCell>
        <TableCell align="right">
          <div onClick={() => navigate('/dashboard/recommendation/tag/edit', { state: row })} aria-hidden>
            <SvgIconStyle src="/icons/send_icon.svg" sx={{ width: 20, height: 20, cursor: 'pointer' }} />
          </div>
        </TableCell>
      </TableRow>
    </>
  );
}
